import { createFileRoute } from "@tanstack/react-router";
import { ManagedSettingsPage } from "@/features/managed-administration/pages/settings-page";
import { tenantContextOptions } from "@/features/managed-administration/queries";
export const Route = createFileRoute("/_authed/managed/tenants/$slug")({ loader: ({ context, params }) => context.queryClient.fetchQuery(tenantContextOptions(params.slug)), component: ManagedSettingsPage });
